export const LocalStorageConstants = {
  keys: {
    token: 'token',
    user_name: 'user_name'
  }
};
